export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Trends-Gray-20e6f3f0cede3857de3a8f4222babf17.svg";